

export const vatListColumns = [
    {
        title: 'Entity',
        dataIndex: 'entity',
        render: entity => entity?.name,
        sorter: true,
    },
    {
        title: 'Percentage',
        dataIndex: 'percentage',
        sorter: true,
    },
    {
        title: 'Description',
        dataIndex: 'description',
        sorter: true,
    },
    {
        title: 'Btw Code',
        dataIndex: 'btw_code',
        sorter: true,
    },
]